import isWithinTargetRange from './targetRange';
import getChangeIcon from './getChangeIcon';

// Display the value with appropriate color coding
export const displayValue = (value, marker) => {
  if (!value || value.raw === "Not Measured") {
    return <span style={{ color: "#F1E0C5" }}>Not Measured</span>;
  }

  if (marker.marker === "Blood Pressure") {
    return <span>{value.systolic}/{value.diastolic} {value.unit}</span>;
  }

  const actualValue = value.num;
  const referenceTarget = marker.target?.reference;
  const userTarget = marker.target?.user;

  if (actualValue === undefined) {
    return <span style={{ color: "#FF0000" }}>Value Missing</span>;
  }

  const isRedFlag = referenceTarget && !isWithinTargetRange(actualValue, referenceTarget);
  const isGreen = userTarget && isWithinTargetRange(actualValue, userTarget);

  const color = isGreen ? "#77b300" : isRedFlag ? "#ff3300" : undefined; 
  return <span style={{ color }}>{value.raw}</span>;
};

export const displayTarget = (target, marker, targetType) => {
  if (!target) return <span>N/A</span>;

  if (marker.marker === "Blood Pressure") {
    const targetData = targetType === 'reference' ? target.reference : target.user;
    if (!targetData) return <span>N/A</span>;
    
    const systolicMin = targetData.systolic_min ?? 'N/A';
    const systolicMax = targetData.systolic_max ?? 'N/A';
    const diastolicMin = targetData.diastolic_min ?? 'N/A';
    const diastolicMax = targetData.diastolic_max ?? 'N/A';
    
    return (
      <span>
        {systolicMin}/{diastolicMin} - {systolicMax}/{diastolicMax}
      </span>
    );
  }

  const targetData = targetType === 'reference' ? target?.reference : target?.user;
  const min = targetData?.min !== null ? targetData?.min : "N/A";
  const max = targetData?.max !== null ? targetData?.max : "N/A";

  return <span>{min} - {max}</span>;
};

export const displayChange = (change, marker) => {
  if (!change) return null;

  if (marker.marker === "Blood Pressure" && typeof change === 'object') {
    const systolicChange = change.systolic?.since_last ?? 0;
    const diastolicChange = change.diastolic?.since_last ?? 0;
    return (
      <div>
        {getChangeIcon(systolicChange)} / {getChangeIcon(diastolicChange)}
      </div>
    );
  }

  // For all other markers, use the since_last value
  const changeValue = change?.since_last ?? 0;
  return (
    <div>
      {getChangeIcon(changeValue)}
    </div>
  );
};